const s4 = (): string => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)

const uid = (prefix?: string): string => {
    const id = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
    return prefix ? `${prefix}-${id}` : id
}

export default uid